import { UPDATE_HOTEL_BASIC_INFO_REQUEST, UPDATE_HOTEL_BASIC_INFO_SUCCESS, UPDATE_HOTEL_BASIC_INFO_FAILURE, UPDATE_HOTEL_BASIC_RESET } from '../types/hotelTypes';

const initState = {
    hotelInfo: [],
    hotelId: "",
    loading: false,
    error: false,
    success: false,
    successMessage: "",
    errorMessage: ""
}

const updateHotelReducer = (state = initState, action) => {
    switch(action.type){
        case UPDATE_HOTEL_BASIC_INFO_REQUEST:
            // console.log('UPDATE HOTEL ', action.payload);
            return {
                ...state,
                loading: true,
                success: false,
                error: false
            }
        case UPDATE_HOTEL_BASIC_INFO_SUCCESS:
            console.log('UPDATE HOTEL SUCCESS ', action.payload);
            return {
                ...state,
                hotelInfo: action.payload,
                hotelId: action.payload.data._id,
                success: true,
                loading: false,
                error: false,
                successMessage:  action.payload.message,
            }
        case UPDATE_HOTEL_BASIC_INFO_FAILURE:
            // console.log('UPDATE HOTEL FAILURE ', action.payload);
            return {
                ...state,
                loading: false,
                error: true,
                success: false,
                errorMessage: action.payload
            }
        case UPDATE_HOTEL_BASIC_RESET:
            // console.log('UPDATE HOTEL FAILURE ', action.payload);
            return {
                ...state,
                loading: false,
                error: false,
                success: false,
            }
        default:
            return state;
    }
}

export default updateHotelReducer;